import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

function App() {
  return <SwaggerUI url="/doc.yaml" />;
}

export default App;
